import useTranslation from 'next-translate/useTranslation';
import { IconBarrierBlock } from '@tabler/icons-react';

import { Button } from '~/domains/design-system/Button';
import { FullScreenMessage } from '~/domains/common/components/FullScreenMessage/FullScreenMessage';

type MyContestInvitesErrorProps = {
  onRetry: () => void;
};

function MyContestInvitesError({ onRetry }: MyContestInvitesErrorProps) {
  const { t } = useTranslation('contest');

  return (
    <FullScreenMessage
      icon={<IconBarrierBlock />}
      title={t('myContests.states.error.invites.title')}
      subtitle={t('myContests.states.error.invites.subtitle')}
      actions={
        <Button size="medium" variant="secondary-fill" onClick={onRetry}>
          {t('myContests.states.error.invites.action')}
        </Button>
      }
    />
  );
}

export default MyContestInvitesError;
